import { render, staticRenderFns } from "./deleteEvent.vue?vue&type=template&id=50825bac&scoped=true"
import script from "./deleteEvent.vue?vue&type=script&lang=js"
export * from "./deleteEvent.vue?vue&type=script&lang=js"
import style0 from "./deleteEvent.vue?vue&type=style&index=0&id=50825bac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50825bac",
  null
  
)

export default component.exports